import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'back-button',
  templateUrl: 'back-button.component.html',
})
export class BackButtonComponent implements OnInit {
  @Input() overrideUrl?: string;

  constructor(
    private router: Router, 
    private navigationService: NavigationService
  ) {}

  ngOnInit() {}

  navigateBack() {
    if (this.overrideUrl) {
      this.router.navigateByUrl(this.overrideUrl);
      return;
    }

    const orignalUrl = this.navigationService.getOriginalUrl();

    if (this.router.url.includes('/list')) {
      const listHomeUrl = this.router.url.split('?')[0].startsWith('/news-bis/list') ? '/news-bis' : '/news';
      this.router.navigateByUrl(listHomeUrl)
    } else {
      this.router.navigateByUrl(orignalUrl);
    }
  }
}
